// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".required{color:#f56c6c;padding-right:5px}.row-bg{padding:10px 0;background-color:#f9fafc}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
